<label class="form-control-label" for="file">
    {{labelName}}
</label>
<input  class="form-control" id="file" type="file" name="test-files" lang="en"
    [accept]="acceptedFileTypes" (change)="onFileSelected($event)" multiple
    />